import React from 'react';
import PropTypes from 'prop-types';

const CurrencyLabel = ({
  amount,
  shouldRound = true,
  showFractionalDigits = false,
  positiveColor = null,
  negativeColor = '#FF6861',
}) => {
  const displayableAmount = shouldRound ? Math.round(amount) : amount;
  const fractionalDigits = showFractionalDigits ? 2 : 0;
  const color = amount < 0 ? negativeColor : positiveColor;

  return (
    <span style={{ color }}>
      {' '}
      {displayableAmount.formatMoney(fractionalDigits)}
    </span>
  );
};

CurrencyLabel.propTypes = {
  amount: PropTypes.number.isRequired,
  shouldRound: PropTypes.bool,
  showFractionalDigits: PropTypes.bool,
  positiveColor: PropTypes.string,
  negativeColor: PropTypes.string,
};

export default CurrencyLabel;
